//import { Box, Fade, Popper } from "@mui/material";
import { ReactNode, useEffect, useRef } from "react";
import './toast.scss'
import { wdpUtil } from "../../common/utils/util";
import { useIsVisible } from "../hooks/useIsVisible";
import { GoabCallout, GoabIconButton } from "@abgov/react-components";
import { GoabCalloutSize, GoabCalloutType } from "@abgov/ui-components-common";
type ToastProps = {
  open: boolean,
  timeout?: number, // time to hide popper in ms
  onClose?: () => void,
  children?: ReactNode,
  type: GoabCalloutType,
  size: GoabCalloutSize,
  msg:string,
};

const defualtTimeout = 3000;

export const Toast = (props: ToastProps) => {
  const mytoast = useRef<HTMLDivElement>(null);
  /************************************************************************************
   * 
  *************************************************************************************/
  useEffect(() => {
    if (props.open) {
      handleOpen();
    }
  });
  /************************************************************************************
   * 
  *************************************************************************************/
  const OnVisible = (_entries: any) => {
    
    const page = document;//.getElementsByTagName(); //mytoast.current;
    if (!wdpUtil.isNullorUndefined(page)) {
      // make content background color same as callout type 
      // const cont = page!.getElementsByClassName('toastContent')[0];
      // if(cont){
      //     console.log(props.type);
      //     (cont as HTMLElement).style.backgroundColor= (props.type === 'success') ? 'var(--goa-color-success-default' : 'var(--goa-color-emergency-default';
      // }
      
      // remove bottom margin
      const callout = page!.getElementsByTagName('goa-callout')[0];
      (callout as HTMLElement).style.marginBottom='0';
      let shadow = callout?.shadowRoot;
      if (shadow?.children !== undefined) {
          const calloutNoti = shadow?.querySelectorAll(".notification")[0];
          if(calloutNoti){
               (calloutNoti as HTMLElement).style.marginBottom='0';
              // (calloutNoti as HTMLElement).style.border='2px solid red';
              // (calloutNoti as HTMLElement).style.position="fixed";
              // (calloutNoti as HTMLElement).style.right="0";
              // (calloutNoti as HTMLElement).style.bottom="0";
              // (calloutNoti as HTMLElement).style.boxShadow="1px 4px 8px rgba(0, 0, 0, 0.5)";


          }
      }
    }
  }
  /************************************************************************************
   * 
  *************************************************************************************/
  const handleOpen = () => {
    setTimeout(handleClose, (props.timeout as number) | defualtTimeout);
  };
  /************************************************************************************
   * 
  *************************************************************************************/
  const handleClose = () => {
    if (typeof (props.onClose) === "function") {
      props.onClose();
    }
  };
  /************************************************************************************
   * 
  *************************************************************************************/
  // call custom Hook
  // the need: 
  // Goa Component Shado JS code is enforceing the callout to have a margin bottom 
  // and this is causing a empty space inside the main ShadowBox we added to the toast 
  // the solution:
  // add a custom hook to catch the OnVisible event and then remove the margin 
  useIsVisible(mytoast, OnVisible);
  /************************************************************************************
   * 
  *************************************************************************************/
  if (props.open) {
    return (
      
        <div className="myToast">
          {/* <GoabCallout type={props.type} size={props.size} testId="MyToast"> */}
          <GoabCallout type={props.type} size='large' testId="MyToast">
            <div className="toastContent">
              <span>{props.msg}</span>
              <GoabIconButton icon="close" variant="dark" onClick={() => { handleClose()}}>
              </GoabIconButton>
            </div>
          </GoabCallout>
        </div>  
      
    )
  }
  return (<></>);
}
